<template>
  <div class="relative z-0">
    <div class="flex flex-row w-full mb-4 sticky top-0 bg-white z-50">
      <div class="border-b-2 w-5 border-gray-200" />

      <div v-for="tab in tabs" :key="tab.key" class="flex flex-row">
        <p
          class="border-b-2 border-gray-200 pb-2 font-semibold cursor-pointer hover:text-brand-800 text-gray-500 text-sm"
          :class="{
            '!border-brand-900 !text-brand-900': selectedTab === tab.key,
          }"
          @click="selectedTab = tab.key"
        >
          {{ tab.label }}
        </p>
        <div class="border-b-2 w-6 border-gray-200" />
      </div>

      <div class="border-b-2 flex-grow border-gray-200" />
      <div class="border-b-2 w-5 border-gray-200" />
    </div>
    <div>
      <template v-for="tab in tabs">
        <div :key="tab.key + '_tab_content'" v-if="tab.key === selectedTab">
          <div class="flex flex-col" v-if="tab.fields?.length">
            <slot name="tab-fields" :tab="tab" />
          </div>
          <div class="p-6 pt-2 flex flex-col gap-6" v-else-if="!!tab.component">
            <div v-if="tab.showHeader ?? true">
              <p v-if="tab.title" class="font-medium">
                {{ tab.title }}
              </p>
              <p v-if="tab.description" class="text-gray-500 text-sm">
                {{ tab.description }}
              </p>
            </div>
            <component :is="tab.component" v-bind="tab.tabAttributes" />
          </div>
          <!-- This value is only for debugging. It should never be shown in a correctly configured setup -->
          <p v-else>
            There's an issue with the configuration of this tab. It has no
            fields or component attached to it
          </p>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const props = defineProps({
  tabs: {
    type: Array,
    required: true,
  },
});

const selectedTab = ref(props.tabs[0].key);
</script>
